.secondaryAction {
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0.6;
}

@media (prefers-reduced-motion: no-preference) {
  .secondaryAction {
    transition: opacity 0.2s;
  }
}

.listItemButton {
  padding: 8px;
  background: transparent;
}

/* Prevent double-hover: the parent ListItem handles the full-width
   hover highlight; the inner button should not add its own. */
.listItemButton.listItemButton:hover {
  background-color: transparent;
}

/* `columns` layout: one dense line. Name, then type and time as fixed columns; time right-aligned. */
.columns {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  min-width: 0;
  min-height: 36px;
  font-family: var(--tuna-typography-fontFamily);
}

.columnsName {
  flex: none;
  min-width: 0;
  overflow-wrap: anywhere;
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-fontSize-md);
  font-weight: 500;
}

.untitled {
  color: var(--tuna-content-secondary);
  font-style: italic;
  font-weight: 400;
}

.columnsMeta {
  display: flex;
  flex: none;
  align-items: center;
  gap: var(--tuna-spacing-1_5);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-fontSize-sm);
}

.columnsType {
  width: 88px;
}

.columnsTime {
  min-width: 112px;
  text-align: right;
  white-space: nowrap;
}

/*
 * The last-editor avatar shares the absolutely positioned secondary action with the overflow button, but ListItem
 * reserves room for the button only. Clear the 24px avatar so the right-aligned time does not run under it.
 */
.clearsLastEditor {
  padding-right: calc(24px + var(--tuna-spacing-1));
}

/* Name over its meta line */
.columnsMain {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
}

.columnsSubline {
  overflow: hidden;
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-fontSize-sm);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The time joins the meta line on phones only */
.sublineTime {
  display: none;
}

.columnsTrailing {
  display: flex;
  flex: none;
  align-items: center;
}

/* Phones: type and time drop under the name as one meta line */
@media (max-width: 599.95px) {
  .columns {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .columnsMeta {
    gap: var(--tuna-spacing-1);
  }

  .columnsType,
  .columnsTime {
    width: auto;
    min-width: 0;
    text-align: left;
  }

  /* With a meta line the row stays two lines: the time moves onto it and the type/time column goes */
  .withSubline .columnsMeta {
    display: none;
  }

  .withSubline .sublineTime {
    display: inline;
  }
}

/* Touch screens: the overflow button is a 44px target */
@media (max-width: 899.95px) {
  .touchAction {
    min-width: 44px;
    min-height: 44px;
  }
}
